<div class="p-form-layout04__item">
  <div class="p-form-layout04__item-title p-form-layout04__item-title--l p-form-layout04__item-title--has-text">
    <div class="p-form-layout04__item-title-label p-form-layout04__item-title-label--em">
      {{ passengerName | passengerName }}
    </div>
    <div
      class="p-form-layout04__item-title-lead"
      *ngIf="passengerTypeLabel !== ''"
      [innerHTML]="passengerTypeLabel | staticMsg"
    ></div>
  </div>
  <div class="p-input-block02">
    <div class="p-input-block02__item" *ngFor="let flight of flightsList">
      <asw-flight-meal-information [traveler]="traveler" [flight]="flight"></asw-flight-meal-information>
    </div>
  </div>
</div>
